export default __webpack_public_path__ + "static/media/5.ec66b7ba.svg";